import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Flex, Box } from '@vezeeta/web-components';

export const IsAlreadyLoggedInModalContainer = styled.div`
  display: none;
`;
export const ModalBackground = styled.div`
  justify-content: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.3);
  bottom: 0;
  box-sizing: border-box;
  left: 0;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  transition-delay: 0s, 75ms, 75ms;
  transition-duration: 125ms, 50ms, 50ms;
  transition-property: top, opacity, z-index;
  transition-timing-function: linear;
  z-index: 100;
  padding: 0px 20px;
  ${props => props.theme.media.desktop`
    padding: 0px;
  `};
`;
export const ModalBox = styled.div`
  background-color: #ffffff;
  height: 160px;
  width: 375px;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  top: 35%;
`;
export const WarningText = styled.p`
  text-align: center;
  color: rgb(0, 112, 205);
  font-weight: 700;
  font-size: 17px;
  margin-bottom: 10px;
`;
export const SubWarningText = styled.p`
  text-align: center;
  color: rgb(116, 116, 112);
`;

export const SignupStepContainer = styled(Box)`
  width: 100%;
  ${props => props.theme.media.desktop`
    width: 60%;   
  `};
  .signup-step {
    margin-bottom: 24px;
    padding: 0 12px;
    .content-container .title {
      margin-bottom: 12px;
    }
    ${props => props.theme.media.desktop`
      margin-bottom: 48px;
      padding: 0 48px;  
      .content-container .title {
        margin-bottom: 24px;
      } 
    `};
  }
`;

export const IllustratedInputsContainer = styled(Flex)`
  flex-direction: column;
  ${props => props.theme.media.tablet`
    flex-direction: row;    
  `};
  ${props => props.theme.media.desktop`
    flex-direction: row;    
  `};
`;

export const InputsContainer = styled(Box)`
  width: 90%;
  ${props => props.theme.media.desktop`
    width: 60%;   
  `};
`;

export const PasswordInputContainer = styled(Flex)`
  position: relative;
`;

export const ShowPassword = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: absolute;
  cursor: pointer;
  right: 0;
  height: 34px;
`;

export const StyledLink = styled(Link)`
  color: #0070cd;
  display: block;
  margin: 0 4px;

  &[data-active] {
    color: red;
  }
`;
